import React from "react";
import { string } from "prop-types";

import ProfileContainer from "../../rows/ProfileContainer";
import EditProfile from "../../molecules/EditProfile";

const EditProfilePage = ({ currentPath }) => (
  <ProfileContainer type="edit-profile" hideTopAd={true} currentPath={currentPath}>
    {({ member }) => <EditProfile member={member} />}
  </ProfileContainer>
);

EditProfilePage.propTypes = {
  currentPath: string,
};

export { EditProfilePage };
